// extracted by mini-css-extract-plugin
export default {"success":"styles_success__oj37H","bounceIn":"styles_bounceIn__7NmEP"};